import StoreCell from './StoreCell';

export default StoreCell;
